import React, { Component } from 'react';
import PropTypes from 'prop-types';
import A from '../Anchor/Anchor';
import { FaFacebookF, FaLinkedin } from 'react-icons/fa';

import './ShareButtons.scss';
import { connect } from 'react-redux';
import IubendaCookieSolution from '../../../utils/iubenda';
import { LogoX } from '../Icons/LogoX';

class ShareButtons extends Component {
  static propTypes = {
    primaryColor: PropTypes.string,
    linkToShare: PropTypes.string,
    twitterMessage: PropTypes.string,
  };

  state = { isConsentGiven: false };

  async componentDidMount() {
    const iubenda = new IubendaCookieSolution(
      this.props.hasIubendaCookieSolution
    );
    const isConsentGiven = await iubenda.isConsentGiven();
    this.setState({
      isConsentGiven,
    });
  }

  handleShare = type => event => {
    const linkToShare = this.props.linkToShare || window.location.href;
    const { twitterMessage } = this.props;

    const linksHash = {
      Facebook: `https://www.facebook.com/sharer/sharer.php?u=${linkToShare}`,
      Twitter: `https://x.com/intent/tweet?text=${encodeURI(
        twitterMessage
      )}&url=${linkToShare}&via=farmakom`,
      Linkedin: `https://www.linkedin.com/shareArticle?mini=true&url=${linkToShare}`,
    };

    this.openLinkInPopup(linksHash[type]);

    // GOOGLE ANALYTICS - CONDIVISIONE SOCIAL
    // ReactGA.event({
    //   category: 'Social',
    //   action: 'Condivisione prodotto',
    //   label: type,
    // });
  };

  openLinkInPopup = URL => {
    window && window.open(URL, '', 'width=500, height=500');
  };

  render() {
    const { primaryColor } = this.props;

    if (!this.state.isConsentGiven) {
      return <div className="share-buttons" />;
    }

    return (
      <div className="share-buttons">
        <A
          className="btn btn-share btn-facebook"
          onClick={this.handleShare('Facebook')}
          style={{
            color: primaryColor,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontSize: 20,
          }}
        >
          <FaFacebookF />
        </A>
        <A
          className="btn btn-share btn-twitter"
          onClick={this.handleShare('Twitter')}
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <LogoX transform="scale(0.8)" fill={this.props.primaryColor} />
        </A>
        <A
          className="btn btn-share btn-twitter"
          onClick={this.handleShare('Linkedin')}
          style={{
            color: primaryColor,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontSize: 20,
          }}
        >
          <FaLinkedin />
        </A>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  primaryColor: state.store.data.loghiTemplate.brandColor,
  hasIubendaCookieSolution: state.store.data.features.hasIubendaCookieSolution,
});

export default connect(mapStateToProps, {})(ShareButtons);
